export default "__VITE_ASSET__Crds3qki__"